import useMediaQuery from '@mui/material/useMediaQuery';
import { theme, Tooltip } from '@raisin/components-lib';
import HelpOutline from '@raisin/components-lib/Icons/HelpOutline';
import { Icon } from '@raisin/cp-legacy-ui-lib';
import { useT } from '@transifex/react';
import messages from 'messages';
import React, { FC } from 'react';
import * as S from './styles';
import { headerColumns, OfferSortingKey, SortDirection } from './utils';

interface HeaderColumnsProps {
  onColumnClick: (col: OfferSortingKey) => void;
  sortColumn: string;
  sortDirection: SortDirection;
  isSavingsOffer: boolean;
}

const EarningsColumnHeader = () => {
  const t = useT();

  return (
    <S.PlainColumnText variant="body1" component="div" data-testid="earnings-tooltip">
      {t(messages.usOfferTableHeaderAnnualizedEarnings)}
      <Tooltip content={t(messages.usOfferTableAnnualizedEarningTooltip)}>
        <S.TooltipButton>
          <HelpOutline size="sm" sx={{ height: 18 }} />
        </S.TooltipButton>
      </Tooltip>
    </S.PlainColumnText>
  );
};

const getSortIcon = (sorted: boolean, dir: SortDirection, title: string) => {
  const skewerTitle = title.toLowerCase().split(' ').join('-');

  const getIconName = () => {
    if (!sorted) return 'sort-default';
    return dir === 'asc' ? 'sort-up' : 'sort-down';
  };

  return (
    <span data-testid={`${skewerTitle}-${getIconName()}`}>
      <Icon icon={getIconName()} round={false} />
    </span>
  );
};

export const HeaderColumnsRow: FC<HeaderColumnsProps> = ({
  onColumnClick,
  sortColumn,
  sortDirection,
  isSavingsOffer,
}) => {
  const t = useT();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  if (isMobile) {
    return null;
  }

  return (
    <S.HeadingsRowContainer $isSavingsOffer={isSavingsOffer}>
      {headerColumns.map((column, index) => {
        const { title, sortable, sortingKey } = column;
        const isSorted = sortColumn === sortingKey;

        if (isSavingsOffer && title === messages.usOfferTableHeaderMaturity) {
          return null;
        }

        if (title === messages.usOfferTableHeaderAnnualizedEarnings)
          return <EarningsColumnHeader key={`${column}-${index}`} />;

        return (
          <span key={`${column}-${index}`}>
            <S.SortableColumnText
              variant="body1"
              onClick={() => {
                onColumnClick(sortingKey);
              }}
            >
              {t(title)}
              {sortable && getSortIcon(isSorted, sortDirection, sortingKey)}
            </S.SortableColumnText>
          </span>
        );
      })}
    </S.HeadingsRowContainer>
  );
};
